import { CardDelivery } from '@apps/card/routes/CardCustomizer/CardCustomizer.types';

export const mapDeliveryMethod = (cardDelivery: CardDelivery | undefined) => {
  if (cardDelivery) {
    if ([CardDelivery.upsCanadaExpressSaver, CardDelivery.upsInternationalExpressSaver].includes(cardDelivery)) {
      return CardDelivery.express;
    }
    if (cardDelivery === CardDelivery.upsGroundCanadaStandard) {
      return CardDelivery.standard;
    }
  }
  return cardDelivery;
};
